import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const BASE = (process.env.REACT_APP_SITE_URL || "").replace(/\/+$/, "");

export const Seo = ({ title, description, path = "/", jsonLd = [], lang = "en-CA", keywords }) => {
  const cleanPath = path === "/" ? "/" : path.replace(/\/+$/, "");
  const url = BASE ? BASE + cleanPath : null;
  const ldKey = JSON.stringify(jsonLd);

  useEffect(() => {
    window.scrollTo(0, 0);
    const scripts = jsonLd.map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ldKey]);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export const faqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: BASE + (!it.path || it.path === "/" ? "/" : it.path.replace(/\/+$/, "")),
  })),
});
